import type { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
    sticky: {
        position: 'sticky',
        top: `calc(var(--layout-top-offset) + ${theme.spacing(3)}px)`,
    },
    isInsideModal: {
        backgroundColor: theme.palette.background.paper,
        zIndex: 2,
        top: 0,
    },
}));

type StickyBoxProps = {
    isInsideModal?: boolean;
};

export const StickyBox: React.FC<PropsWithChildren<StickyBoxProps>> = ({
    children,
    isInsideModal,
}) => {
    const classes = useStyles();

    return (
        <div
            className={classNames('StickyBox', classes.sticky, {
                [classes.isInsideModal]: isInsideModal,
            })}
        >
            {children}
        </div>
    );
};
